import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mt-6 shadow-custom overflow-x-auto rounded-xl max-h-90 overflow-y-auto bg-white border border-gray-100" }
const _hoisted_3 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", { class: "w-full bg-primary-light-blue" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "flex w-full" }, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "align-top px-3 py-3 w-1/4 text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
    }, " Nimi "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "align-top px-3 py-3 w-1/4 text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
    }, " Kontaktisik "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "align-top px-3 py-3 w-1/4 text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
    }, " Töötajaid "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "align-top px-3 py-3 w-1/4 text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
    }, " Ülesvõtted ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardHomeClinicsListItem = _resolveComponent("DashboardHomeClinicsListItem")!

  return (_ctx.clinics.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("table", _hoisted_3, [
            _hoisted_4,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clinics, (clinic) => {
              return (_openBlock(), _createBlock(_component_DashboardHomeClinicsListItem, {
                key: clinic.uid,
                clinic: clinic
              }, null, 8, ["clinic"]))
            }), 128))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}